import React, { Component } from "react";
import { Link } from "react-router-dom";
class Carees_SideBar extends Component {
  render() {
    return (
      <div id="sidebar">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={0}
          data-smobile={0}
        />
        <div id="inner-sidebar" className="inner-content-wrap">
          <div className="widget widget_list">
            <div className="inner">
              <ul className="list-wrap">
                <li className="list-item">
                  <Link
                    to="/about/startups"
                    onClick={() => {
                      window.location.href = "/about/startups";
                    }}
                  >
                    <span className="text">Zašto odabrati startup?</span>
                  </Link>
                </li>
                <li className="list-item">
                  <Link
                    to="/about/cityx-team"
                    onClick={() => {
                      window.location.href = "/about/cityx-team";
                    }}
                  >
                    <span className="text">CityX Team</span>
                  </Link>
                </li>
                <li className="list-item">
                  <Link
                    to="/about/carees"
                    onClick={() => {
                      window.location.href = "/about/carees";
                    }}
                  >
                    <span className="text">Karijere</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={0}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    );
  }
}

export default Carees_SideBar;
